import React from "react";
//#region types
//#endregion
//#region components
import { ContentCard } from "components/common";
import useEULADetails from "./hooks/useEULADetails";
//#endregion

const EULAContent: React.FC = (props) => {
  const { getEULADetails } = useEULADetails();
  const EULADetails = getEULADetails();

  return (
    <>
      {EULADetails !== undefined &&
        EULADetails.map((contentTree, index) => (
          <ContentCard key={`content-${index}`} contentTree={contentTree} currentIndex={index}></ContentCard>
        ))}
    </>
  );
};

export default EULAContent;
